import dayjs from 'dayjs';
import { createContext } from 'react';

import { DATE_PICKER_FORMAT, emptyFn } from '@app/constants';
import { initialClientsFilter, initialVisitsFilter } from '@app/data';
import { initialFiltersConfig } from '@app/pages/Clients/ClientsList/data/initialFiltersConfig';
import type { NClientFiltersProvider } from '@app/providers/ClientFiltersProvider/ClientFiltersProvider.types';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

const dateFormatList = DATE_PICKER_FORMAT;
const [todayDate] = new Date().toISOString().split('T');

export const ClientFiltersContext = createContext<NClientFiltersProvider.State>(
  {
    filters: {
      VisitsFilter: initialVisitsFilter,
      ClientsFilter:
        initialClientsFilter as NClientsList.Filters['ClientsFilter'],
    },
    todayDate: new Date().toISOString().split('T')[0],
    initialDate: dayjs(todayDate, dateFormatList[1]),
    dateFormatList,
    checkedKeys: [],
    allCategoriesAndServices: [],
    searchedCategoriesAndServices: [],
    searchedCategories: [],
    allTags: [],
    searchedTags: [],
    allTagsWithoutAdaptation: [],
    allEmployees: [],
    serverFilters: {
      VisitsFilter: initialVisitsFilter,
      ClientsFilter:
        initialClientsFilter as NClientsList.Filters['ClientsFilter'],
    },
    filterGroups: [],
    specificFilterId: null,
    tagIncludingStatuses: [true],
    defaultTagIncludingStatuses: [true],
    tagsStorageKey: '',
    memoizedServerFilters: initialFiltersConfig,
    searchTerm: '',
    setSearchTerm: emptyFn,
    setTagIncludingStatuses: () => {},
    setSpecificFilterId: emptyFn,
    setFilterGroups: emptyFn,
    handleDisabling: () => true,
    setUpServerDataChunk: () => initialFiltersConfig,
    setServerFilters: emptyFn,
    clearVisitsGroup: emptyFn,
    clearClientsGroup: emptyFn,
    setAllEmployees: emptyFn,
    setAllTagsWithoutAdaptation: emptyFn,
    setSearchedTags: emptyFn,
    setAllTags: emptyFn,
    setSearchedCategories: emptyFn,
    setSearchedCategoriesAndServices: emptyFn,
    setAllCategoriesAndServices: emptyFn,
    setCheckedKeys: emptyFn,
    setFilters: emptyFn,
    handleRangeChange: emptyFn,
    onChangeFiltersHandler: emptyFn,
    getClientTagsIncluding: () => false,
    clearGroupBothTagArrays: emptyFn,
    deleteTagsIncludingStatus: emptyFn,
    allRecordTags: [],
    recordSearchedTags: [],
    allRecordTagsWithoutAdaptation: [],
    setAllRecordTags: () => {},
    setRecordSearchedTags: () => {},
  }
);
